var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1725 7.00163L8.58651 13.5876C8.39549 13.7721 8.24312 13.9928 8.13831 14.2368C8.03349 14.4808 7.97831 14.7433 7.97601 15.0088C7.9737 15.2744 8.0243 15.5377 8.12486 15.7835C8.22543 16.0293 8.37393 16.2526 8.56172 16.4404C8.7495 16.6282 8.97281 16.7767 9.2186 16.8773C9.46439 16.9778 9.72775 17.0284 9.99331 17.0261C10.2589 17.0238 10.5213 16.9687 10.7653 16.8638C11.0093 16.759 11.23 16.6066 11.4145 16.4156L17.8285 9.82963C18.5571 9.07522 18.9603 8.06481 18.9512 7.01602C18.9421 5.96724 18.5214 4.96399 17.7798 4.22235C17.0381 3.48072 16.0349 3.06005 14.9861 3.05093C13.9373 3.04182 12.9269 3.445 12.1725 4.17363L5.75751 10.7586C4.63219 11.8839 4 13.4102 4 15.0016C4 16.5931 4.63219 18.1193 5.75751 19.2446C6.88282 20.3699 8.40907 21.0021 10.0005 21.0021C11.5919 21.0021 13.1182 20.3699 14.2435 19.2446L20.5005 13.0016",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperClip);
export default __webpack_public_path__ + "static/media/paper-clip.d343a5bf0a9c69b6ff83fc19f3d0cbc3.svg";
export { ForwardRef as ReactComponent };